import PropTypes from 'prop-types';
import styles from 'styles/CommentItem.module.scss';
import { useTranslations } from 'next-intl';

const CommentItem = ({ data }) => {
    const t = useTranslations('comments.comment');
    let commentDescription = t('commented-today');

    if (data.datetime > 0) {
        commentDescription = t('description').replace(
            '[datetime]',
            data.datetime
        );
    };

    return (
        <div className={styles.container} itemProp="comment" itemScope itemType="http://schema.org/Comment">
            <div className={styles.comment}>
                <span itemProp="dateCreated" style={{ display: 'none' }}>{data.created_at}</span>
                <div className={styles.comment_description}>
                    <p itemProp="author" itemScope itemType="https://schema.org/Person">
                        <strong itemProp="name">{data.name || 'Anon'} </strong>
                    </p>
                    {commentDescription}
                </div>
                <div className={styles.comment_text} itemProp="text">
                    {data.comment}
                </div>
            </div>
        </div>
    );
};

CommentItem.propTypes = {
    data: PropTypes.object
};

export default CommentItem;
